<script lang="ts">
  import { t } from 'svelte-i18n';

  export let label: string;
  export let options: string[];
  export let multiple = false;
  export let selectedOptions: string[] = [];

  function selectOption(index: number) {
    if (!multiple) {
      selectedOptions = selectedOptions.includes(options[index]) ? 
      [] : [options[index]];
      return;
    }
    
    if (selectedOptions.includes(options[index])) {
      selectedOptions = selectedOptions.filter((value) => value !== options[index]);
      return;
    } 

    selectedOptions = [...selectedOptions, options[index]];
  }
</script>

<p class="c-contact__option-label">{@html $t(label)}</p>
<div class="c-contact__option">
  {#each options as option, i}
    <p class="c-contact__option-chip u-highlight--none" on:click={() => selectOption(i)} 
    class:c-contact__option-chip--active={selectedOptions.includes(option)}>
      {@html $t(option)}
    </p>
  {/each}
</div>

<style lang="scss">
  .c-contact__option {
    @apply flex flex-row justify-center md2:justify-start flex-wrap gap-3;

    &-label {
      @apply text-[0.875rem] xs:text-base md:text-xxs md2:text-xs text-center md2:text-left mb-6 p-0 text-white opacity-[0.9] leading-snug;

      strong {
        font-weight: 600;
      }
    }

    &-chip {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px 16px;
      border-radius: 20px;
      border: 1px solid rgba(255, 255, 255, 0.50);
      color: rgba(255, 255, 255, 0.80);
      font-size: 16px;
      text-align: center;
      cursor: pointer;

      small {
        font-size: 16px;
        color: rgba(255, 255, 255, 0.60);
      }

      &:active {
        border-color: #160F32;
      }

      &--active {
        color: rgba(255, 255, 255, 0.90);
        background-color: rgba(255, 255, 255, 0.15);
      }
    }
  }
</style>